var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 317.75 200.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d61983;opacity:0.4;}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#0e0e0e;stroke-miterlimit:10;stroke-width:3px;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-559.65,188.57c-38.5-14-84.84-30.66-88.52-25.76-5.71,7.62,17.53,15.11,17.67,26.29s-14.48,31.33-7.18,67.55,27.08,47.2,29.81,58.66-15.94,24-8.84,34.36c4.75,8.5,113.17-84.46,113.17-84.46l-10.1-60.37s-7.08-2.17-28.43-10",
    transform: "translate(697.7 -149.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-550.14,177.94c-38.5-14-84.85-30.65-88.52-25.75-5.72,7.62,17.53,15.11,17.67,26.28s-14.48,31.33-7.18,67.55,27.08,47.21,29.81,58.67S-614.3,328.64-607.2,339c4.75,8.51,113.17-84.45,113.17-84.45l-10.1-60.37s-7.08-2.17-28.43-10",
    transform: "translate(697.7 -149.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-436.4,236.36l13.93-2.38a22.42,22.42,0,0,0,18.27-25.8h0a22.44,22.44,0,0,0-23.38-18.54,22.43,22.43,0,0,0-2.42.28",
    transform: "translate(697.7 -149.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-433.45,235.86c-17.2,2.44-26.68-5.64-28.75-17.76h0a22.42,22.42,0,0,1,18.27-25.8l13.93-2.38s8.23,12,3.58,18C-438.6,223.6-433.45,235.86-433.45,235.86Z",
    transform: "translate(697.7 -149.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-583.88,238.76l-108.29,19.46s-3,6.12-.44,10.71,7.8,9.24,25.28,7.64,162.13-21.74,162.13-21.74,16.46-1.89,26.94,3.18,24,11.79,30.78,10.86,62.19-11.45,62.19-11.45,5.12-1.34,3.53-7.94-5.45-7.26-5.45-7.26-49.74,7.52-57,7.85-21.9-6.91-25-11.73,9.91-12,9.91-12l-2.59-17.14s-14.67-2.39-13.31-8,12.74-17.27,19.71-19.37,56.37-11.52,56.37-11.52,3.44-1.91,2.74-8.66-6-6.31-6-6.31-55.77,8.47-62.47,9.84-17.22,12.19-25.42,20.45-24.36,12-24.36,12-143.13,29-160.15,33.31-20.43,10.42-21.31,15.6,3.92,11.66,3.92,11.66l108.65-19.3Z",
    transform: "translate(697.7 -149.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-546.14,259.46c-3.23-17.44-6.41-34.66-9.82-53.13-5.24,6-28.39,27.67-27.92,32.43S-552.7,256.41-546.14,259.46Z",
    transform: "translate(697.7 -149.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperts);
export default __webpack_public_path__ + "static/media/experts.38f16ae08d09b31c299b3a685893e847.svg";
export { ForwardRef as ReactComponent };